import {SxProps} from '@mui/material';

export const STYLES = {
  grid: {
    p: 0,
    gap: '20px 10px',
  },
  item: {
    p: '16px',
    borderRadius: '14px',
    background: '#fff',
    minHeight: '200px',
    ml: 'auto',
  },
} as const satisfies SxProps;
